import React, { useRef, useState } from "react";
import { Form, Button, Card, Alert, Container, Row, Image } from 'react-bootstrap'
import { useAuth } from '../contexts/AuthContext'
import { Link, useHistory } from 'react-router-dom'

function Signup() {

    const emailRef = useRef()
    const passwordRef = useRef()
    const passwordConfirmlRef = useRef()
    const { signup } = useAuth()
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const history = useHistory()

    async function handleSubmit(e) {
        e.preventDefault()

        if (passwordRef.current.value !== passwordConfirmlRef.current.value) {
            return setError("Passwords do not match")
        }

        try {
            setError("")
            setLoading(true)
            await signup(emailRef.current.value, passwordRef.current.value)
            history.push("/scan")
        } catch {
            setError("Failed to create an account")
        }
        setLoading(false)

    }




    return (
        <>
            <Container>
                <Row className="justify-content-center">
                    <Card className="w-100 mt-4" style={{ maxWidth: "400px" }}>
                        <Card.Body>
                            {/* <h2 className="text-center mb-4">Sign Up</h2> */}
                            <Image style={{ maxWidth: "80px", height: "auto" }} className="auth-logo" src="/proion-logo.png" />
                            {error && <Alert variant="danger">{error}</Alert>}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group id="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" ref={emailRef} required></Form.Control>
                                </Form.Group>
                                <Form.Group id="password">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control type="password" ref={passwordRef} required></Form.Control>
                                </Form.Group>
                                <Form.Group id="password-confirm">
                                    <Form.Label>Password Confirmation</Form.Label>
                                    <Form.Control type="password" ref={passwordConfirmlRef} required></Form.Control>
                                </Form.Group>
                                <Button disabled={loading} className="w-100 signup-btn" type="submit">Sign Up</Button>
                            </Form>
                        </Card.Body>
                    </Card>
                    <div className="w-100 text-center mt-2">
                        Already have an account? <Link className="auth-link" to="/login">Log In</Link>
                    </div>
                </Row>
            </Container>

        </>
    )
}

export default Signup